'use strict';

module.exports = [
  '$injector',
  DomainErrorFunction];

function DomainErrorFunction() {

}


// WEBPACK FOOTER //
// ./src/js/core-utilities/domain/DomainErrorDirective.js